module.exports = __webpack_public_path__ + "img/molmer-sorensen.412ea8d9.svg";